<template>
  <div>
    <MMP_HDT_PointCloud
      :incomingData="outgoingData"
      :inputtingPCPT="inputtingPCPT"
      @cleared="clearOutgoingData()"
    ></MMP_HDT_PointCloud>
    <b-modal
      id="hardDriveTrackingModal"
      size="xl"
      content-class="menu-bg-blue-transparent-modal hdt-modal"
      body-class="scroll-Container"
      title="Hard Drive Tracking"
      hide-footer
     
      scrollable
      @show="loadHardDriveTracking()"
    >
      <b-container class="table-fill-container">
        <MMP_QueryConstructor
          :comp="'HDT'"
          :spinner="queryConstructorSpinner"
          :getConditions="getConditions"
          :jdayData="[calculateTodayMinusXJdays(0), calculateTodayMinusXJdays(7)]"
          @applyCustomQuery="applyCustomQuery($event)"
          @startSpinner="customQueryRunning()"
        ></MMP_QueryConstructor>
        <vue-bootstrap4-table
          ref="vbt_hdt"
          v-if="!driveTrackingSpinner"
          :rows="hardDriveTrackingRows"
          :columns="hardDriveTrackingColumns"
          :config="config"
          :actions="actions"
          :classes="classes"
          @on-select-row="rowClicked($event)"
        >
          <template slot="field_sn" slot-scope="props">
            <div :class="!props.cell_value ? 'vacant-red' : ''">
              {{ !props.cell_value ? 'UNLABELED' : props.cell_value }}
            </div>
          </template>
          <template slot="backup" slot-scope="props">
            <div v-if="props.cell_value != null">
              {{ props.cell_value ? 'Yes' : 'No' }}
            </div>
          </template>
          <template slot="jday_date" slot-scope="props">
            {{
              props.row.julian_day != null
                ? getJdayInDateFormat(props.row.julian_day)
                : ''
            }}
          </template>
          <template slot="subcountry" slot-scope="props">
            <div v-if="props.cell_value != null">
              <b-row v-for="(subc, index) in props.cell_value" :key="index">
                <b-col>
                  {{
                    index + 1 == props.cell_value.length ? subc : subc + ', '
                  }}
                </b-col>
              </b-row>
            </div>
          </template>
          <template slot="assigned_user" slot-scope="props">
            <div>
              {{ ['ushr_fieldqc', 'ushr_jenkins', null].includes(props.cell_value) ? '' : props.cell_value }}
            </div>
          </template>
          <template slot="collection_type" slot-scope="props">
            {{ determineCollectionTypes(props.row) }}
          </template>
          <template slot="start_date" slot-scope="props">
            {{
              props.cell_value != null
                ? new Date(props.cell_value).toLocaleString('en-US', {
                    dateStyle: 'short'
                  })
                : ''
            }}
          </template>
          <template slot="complete_date" slot-scope="props">
            {{
              props.cell_value != null
                ? new Date(props.cell_value).toLocaleString('en-US', {
                    dateStyle: 'short'
                  })
                : ''
            }}
          </template>
          <template slot="miles" slot-scope="props">
            {{
              parseFloat(
                (
                  props.row.aerial_miles +
                  props.row.cm_miles +
                  props.row.primary_miles +
                  props.row.ramp_miles +
                  props.row.secondary_miles +
                  props.row.tertiary_miles
                ).toFixed(2)
              )
            }}
          </template>
          <template slot="received" slot-scope="props">
            <fa
              v-if="props.row.received_date != null"
              :icon="['fas', 'check']"
            />
          </template>
        </vue-bootstrap4-table>
      </b-container>
    </b-modal>
  </div>
</template>

<style>
@media (min-width: 768px) {
  .modal-xl {
    width: 95%;
    max-width: 1600px;
  }
}
.comments-text {
  font-size: 16px;
}
.date-column-width {
  min-width: 125px;
}
.downDayHighlight {
  background-color: rgba(255, 83, 83, 0.5);
}
.partialDownDayHighlight {
  background-color: rgba(217, 255, 93, 0.5);
}
.table-fill-container {
  width: 100%;
  margin-left: 0%;
  margin-right: 0%;
  max-width: 100%;
}
.vacant-red {
  color: red;
}
.pointer-cursor {
  cursor: pointer;
}

/* ── HDT Hard Drive Tracking modal table ─────────────────────── */
.hdt-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.hdt-modal table { color: #063c6d !important; text-shadow: none !important; }
.hdt-modal thead th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  text-shadow: none !important;
}
.hdt-modal thead th a,
.hdt-modal thead th svg { color: rgba(6, 60, 109, 0.5) !important; }
.hdt-modal tbody tr { color: #063c6d !important; text-shadow: none !important; }
.hdt-modal tbody tr:hover { background: rgba(6, 60, 109, 0.04) !important; }
.hdt-modal tbody td {
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.08) !important;
  text-shadow: none !important;
}
.hdt-modal .footer-pagination-row td,
.hdt-modal .footer-pagination-row th {
  background: rgba(6, 60, 109, 0.06) !important;
  color: #063c6d !important;
  border-color: rgba(6, 60, 109, 0.12) !important;
  text-shadow: none !important;
}
</style>

<script>
import MMP_HDT_PointCloud from './MMP_HDT_PointCloud.vue'
import MMP_QueryConstructor from '../shared/MMP_QueryConstructor.vue'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'

export default {
  name: 'MMP_HardDriveTracking',
  components: {
    MMP_HDT_PointCloud,
    MMP_QueryConstructor,
    VueBootstrap4Table
  },
  data() {
    return {
      app: 'hdt',
      hardDriveTrackingRows: [],
      hardDriveTrackingColumns: [
        {
          label: 'Drive',
          name: 'field_sn',
          sort: true
        },
        {
          label: 'Backup',
          name: 'backup',
          sort: false
        },
        {
          label: 'System',
          name: 'system',
          sort: true
        },
        {
          label: 'Jday',
          name: 'julian_day',
          sort: true
        },
        {
          label: 'Date',
          name: 'jday_date',
          sort: true
        },
        {
          label: 'State',
          name: 'subcountry',
          sort: false
        },
        {
          label: 'Assigned User',
          name: 'assigned_user',
          sort: true
        },
        {
          label: 'Collection Type',
          name: 'collection_type',
          sort: false
        },
        {
          label: 'Status',
          name: 'status',
          sort: true
        },
        {
          label: 'Date Started',
          name: 'start_date',
          sort: true
        },
        {
          label: 'Date Completed',
          name: 'complete_date',
          sort: true
        },
        {
          label: 'Miles',
          name: 'miles',
          sort: false
        },
        {
          label: 'Received',
          name: 'received',
          sort: false
        }
      ],
      actions: [],
      config: {
        checkbox_rows: false,
        card_mode: false,
        card_title: 'Hard Drive Tracking',
        global_search: {
          placeholder: 'Search...',
          visibility: true,
          showClearButton: true,
          searchOnPressEnter: true
        },
        highlight_row_hover_color: 'rgba(6,60,109,0.04)',
        per_page: 100,
        per_page_options: [10, 15, 25],
        rows_selectable: true,
        show_refresh_button: false,
        show_reset_button: false
      },
      classes: {
        table: {
          'menu-bg-blue-transparent-modal': true
        },
        row: {
          'pointer-cursor': true
        }
      },
      driveTrackingSpinner: false,
      outgoingData: null,
      queryConstructorSpinner: false,
      inputtingPCPT: false,
      getConditions: []
    }
  },
  methods: {
    inputPCPT() {
      this.inputtingPCPT = true
      this.$bvModal.show('pointCloudProcessTrackingModal')
    },
    rowClicked(e) {
      let selectedRow = e.selected_item
      let table = this.$refs.vbt_hdt

      // forEach block deselects previously selected row(s)
      table.selected_items.forEach(row => {
        if (row.vbt_id != selectedRow.vbt_id) {
          table.removeSelectedItem(row)
        }
      })

      this.getAutofillData(selectedRow)
    },
    determineCollectionTypes(row) {
      let retVal = ''
      let retValArr = []

      if (row.aerial_miles != null && row.aerial_miles != 0) {
        retValArr.push('Aerial Recollect')
      }
      if (row.cm_miles != null && row.cm_miles != 0) {
        retValArr.push('CM')
      }
      if (row.primary_miles != null && row.primary_miles != 0) {
        retValArr.push('Primary')
      }
      if (row.secondary_miles != null && row.secondary_miles != 0) {
        retValArr.push('Secondary')
      }
      if (row.tertiary_miles != null && row.tertiary_miles != 0) {
        retValArr.push('Tertiary')
      }
      if (row.ramp_miles != null && row.ramp_miles != 0) {
        retValArr.push('Ramps')
      }

      for (let type in retValArr) {
        retVal += retValArr[type] + ', '
      }

      // Cuts last ', ' off the string
      retVal = retVal.slice(0, retVal.length - 2)

      return retVal
    },
    applyCustomQuery(queryRows) {
      this.hardDriveTrackingRows = queryRows.rows
      this.getConditions = queryRows.cond
      this.queryConstructorSpinner = false
      this.driveTrackingSpinner = false
    },
    customQueryRunning() {
      this.hardDriveTrackingRows = []
      this.driveTrackingSpinner = true
    },
    loadHardDriveTracking() {
      if (this.hardDriveTrackingRows.length == 0) {
        this.hardDriveTrackingRows = []
        this.driveTrackingSpinner = true
        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION + '/api/drive_tracking/drive_tracking',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  current_julian_day: this.calculateTodayMinusXJdays(0),
                  seven_julian_days_ago: this.calculateTodayMinusXJdays(7)
                }
              }
            )
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log('Drive Tracking API Call Error: ' + content.errors)
              } else {
                this.hardDriveTrackingRows = content.rows
                this.driveTrackingSpinner = false
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
      }
    },
    calculateTodayMinusXJdays(daysToSubtract) {
      let rightNow = new Date()
      let msPerDay = 86400000
      let requestedJdayDate = new Date(rightNow.getTime() - (daysToSubtract * msPerDay))
      let jdayYear = requestedJdayDate.getFullYear()
      let start = new Date(requestedJdayDate.getFullYear(), 11, 31)
      let leapYear = (jdayYear % 4 == 0 && jdayYear % 100 != 0) || jdayYear % 400 == 0
      let diff = 365 + leapYear - Math.ceil((start - requestedJdayDate) / msPerDay)
      let jdayDay = ('000' + diff).slice(-3)
      return jdayYear.toString().substr(-2) + jdayDay // e.g. returns "23142"
    },
    clearOutgoingData() {
      this.inputtingPCPT = false
      this.outgoingData = null
    },
    closeTracking() {
      this.$bvModal.hide('hardDriveTrackingModal')
    },
    getAutofillData(rowData) {
      // axios call to get possible Jdays to autopopulate PCPT form
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION +
              '/api/drive_tracking/point_cloud_process_tracking',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                trackId: rowData.track_id
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log(
                'Point Cloud Process Tracking API Call Error: ' + content.errors
              )
            } else {
              this.outgoingData = content.rows[0]
              this.inputPCPT()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getJdayInDateFormat(jday) {
      let retVal = ''
      let finished = false
      let year = 2000 + Number(jday.toString().substring(0, 2))
      let dayOfYear = Number(jday.toString().substring(2))
      let leapYear = (year % 4 == 0 && year % 100 != 0) || year % 400 == 0
      let monthDays = [
        31,
        leapYear ? 29 : 28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ]
      monthDays.forEach((days, index) => {
        if (dayOfYear - days > 0) {
          dayOfYear -= days
        } else if (!finished) {
          finished = true
          retVal = new Date(
            index + 1 + '/' + dayOfYear + '/' + year
          ).toLocaleString('en-US', {dateStyle: 'short'})
        }
      })
      return retVal
    }
  }
}
</script>
